export enum EAggregationAnalysisSummaryFlag {
  CASUAL_COLUMN = 'N',
  SUMMARY_COLUMN = 'Y',
}

export interface IAggregationAnalysisSector {
  id: number
  sector: string
  summaryFlag: string
  laterYear: number
  laterQuarter: number
  aggType: string
  formerYear: number
  formerQuarter: number
  // counts
  laterQrtrCount: number
  formerQrtrCount: number
  commonCount: number
  // earnings
  consErngsGr?: number
  prxErngsGr?: number
  spreadErngsGr?: number
  actErngsGr?: number
  // revenues
  consRevGr?: number
  prxRevGr?: number
  spreadRevGr?: number
  actRevGr?: number
}

export interface IAggregationAnalysisQuarter {
  id: number
  laterYear: number
  laterQuarter: number
  commonCount: number
  // earnings
  consErngsGr?: number
  prxErngsGr?: number
  spreadErngsGr?: number
  actErngsGr?: number
  // revenues
  consRevGr?: number
  prxRevGr?: number
  spreadRevGr?: number
  actRevGr?: number
}

export enum EAggregationAnalysisType {
  YEAR_ON_YEAR = 'YoY',
  QUARTER_ON_QUARTER = 'QoQ',
}

export enum EAggregationAnalysisPath {
  SECTOR = 'sector',
}

export interface IAggregationAnalysisChart {
  year: number
  quarter: number
  title: string
  maxValue: number
  consGr: number
  prxGr: number
  actGr: number
}
